import { Particle, type ParticleOptions } from "../Particle";
import { adjustColor } from "../../utils/color";
import { PhaseChange } from "../behaviors/PhaseChange";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { Lava } from "./Lava";

export class Stone extends Particle {
    static baseColor = 0x8D99A6; // Cool Grey

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Stone",
            color: adjustColor(Stone.baseColor, 15),
            behaviors: [
                new PhaseChange([
                    { temp: 1000, type: 'above', factory: () => new Lava({ temperature: 1020 }) }
                ]),
                new TemperatureNormalization(20, 0.1) // 缓慢恢复温度
            ],
            props: { isMixable: false, thermalConductivity: 0.05 }, // 极低导热率，很难被加热融化
            temperature: 20,
            minTemp: -273,
            maxTemp: 5000,
            ...options
        });
    }
}
